import {
    GET_COMPLIANCE_REPORT_GRID_DATA,
    SET_COMPLIANCE_REPORT_GRID_DATA,
    GET_COMPLIANCE_REPORT_TABLE_EXCEL,
    SET_COMPLIANCE_REPORT_TABLE_EXCEL,
    SET_COMPLIANCE_REPORT_FILTER_DATA,
    GET_COMPLIANCE_MODIFICATION_REPORT,
    SET_COMPLIANCE_MODIFICATION_REPORT,
    GET_APPROVER_UPDATES_GRID_DATA,
    SET_APPROVER_UPDATES_GRID_DATA,
    GET_COMPLIANCE_AUDIT_EXPORT_EXCEL,
    SET_COMPLIANCE_AUDIT_EXPORT_EXCEL
} from "./ComplainceReportType"

const getComplianceReportGridData = (payload: any) => ({
    type: GET_COMPLIANCE_REPORT_GRID_DATA,
    payload
})

const setComplianceReportGridData = (complianceReportGridData: any) => ({
    type: SET_COMPLIANCE_REPORT_GRID_DATA,
    complianceReportGridData: complianceReportGridData
})
const getComplianceReportTableExcel = (payload: any) => ({
    type: GET_COMPLIANCE_REPORT_TABLE_EXCEL,
    payload
})

const setComplianceReportTableExcel = (complianceReportTableExcel: any) => ({
    type: SET_COMPLIANCE_REPORT_TABLE_EXCEL,
    complianceReportTableExcel: complianceReportTableExcel
})

const setComplianceReportFilterData = (complianceReportFilterData: any) => ({
    type: SET_COMPLIANCE_REPORT_FILTER_DATA,
    complianceReportFilterData: complianceReportFilterData
})

const getComplianceModificationReport = (payload: any) => ({
    type: GET_COMPLIANCE_MODIFICATION_REPORT,
    payload
})

const setComplianceModificationReport = (complianceModificationReport: any) => ({
    type: SET_COMPLIANCE_MODIFICATION_REPORT,
    complianceModificationReport: complianceModificationReport
})

const getApproverUpdatesGridData = (payload: any) => ({
    type: GET_APPROVER_UPDATES_GRID_DATA,
    payload
})

const setApproverUpdatesGridData = (approverUpdatesGridData: any) => ({
    type: SET_APPROVER_UPDATES_GRID_DATA,
    approverUpdatesGridData: approverUpdatesGridData
})

const getcomplianceAuditExportExcel = (payload?: any) => ({
    type: GET_COMPLIANCE_AUDIT_EXPORT_EXCEL,
    payload
})

const setcomplianceAuditExportExcel = (complianceAuditExportExcel?: any) => ({
    type: SET_COMPLIANCE_AUDIT_EXPORT_EXCEL,
    complianceAuditExportExcel: complianceAuditExportExcel
})

export {
    getComplianceReportGridData,
    setComplianceReportGridData,
    getComplianceReportTableExcel,
    setComplianceReportTableExcel,
    setComplianceReportFilterData,
    getComplianceModificationReport,
    setComplianceModificationReport,
    getApproverUpdatesGridData,
    setApproverUpdatesGridData,
    getcomplianceAuditExportExcel,
    setcomplianceAuditExportExcel
}